var _circle, _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgResetFilterIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.4604,
    cy: 18.0972,
    r: 17.4644,
    fill: "#3C3ADA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13361_31522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6276 11.9303C22.0449 10.3476 19.8728 9.36523 17.4605 9.36523C12.636 9.36523 8.73926 13.2729 8.73926 18.0974C8.73926 22.9219 12.636 26.8296 17.4605 26.8296C21.5319 26.8296 24.9265 24.0462 25.898 20.2805H23.6276C22.7326 22.8237 20.3094 24.6465 17.4605 24.6465C13.8476 24.6465 10.9114 21.7104 10.9114 18.0974C10.9114 14.4845 13.8476 11.5483 17.4605 11.5483C19.2724 11.5483 20.8879 12.3014 22.0667 13.4912L18.552 17.0059H26.1927V9.36523L23.6276 11.9303Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13361_31522"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.1965,
    height: 26.1965,
    fill: "white",
    transform: "translate(4.3623 4.99902)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgResetFilterIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ResetFilterIcon.177909b1.svg";
export { ForwardRef as ReactComponent };